import { Router } from '@angular/router';
import { FirestoreService } from './../shared/services/firestore/firestore.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import swal from 'sweetalert2';
import { DatePipe } from '@angular/common';
import { SaludService } from '../shared/services/apiSalud/salud.service';

declare var $: any;

@Component({
  selector: 'app-rengo-form',
  templateUrl: './rengo-form.component.html',
  styleUrls: ['./rengo-form.component.css']
})
export class RengoFormComponent implements OnInit {
  matcher;
  rengoForm: FormGroup;
  validEmail = false;
  validRUT = false;
  isSpinning: boolean = false;
  timeout;
  public _goBack = "< Regresar";
  public virtualLendings = [];
  public inSituLendings = [];
  public sortedLendings = [];
  public _connectionType = "";

  constructor(
    private formBuilder: FormBuilder,
    private firestoreService: FirestoreService,
    private datePipe: DatePipe,
    private saludService: SaludService
  ) { }

  ngOnInit() {
    this.saludService.validarFecha()
      .toPromise()
      .then( (resp: any) => {
        // console.log(resp)
        let { day, hour } = resp;
        const [hora, minuto, segundo] = hour.split(':');
        day = day.dayString;
        if((day === 'Viernes' && hora >= 16) || (day === 'Sabado') || (day === 'Domingo') || (day === 'Lunes' && hora < 8)){
          swal({
            title: " ¡Lo sentimos!",
            text: "El horario de solicitud de hora es de Lunes a Jueves las 24 hrs y Viernes hasta las 16:00 horas, por favor, intente nuevamente más tarde.",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success",
            type: "success"
          }).then(() => {
            window.location.href = 'https://salud.municipalidadrengo.cl/';
          }).catch(swal.noop)
        }else{
            console.log(`Fecha ${day} - Hora: ${hour}`);
        }
      })
      .catch( (err) => {
        console.log('error', err)
        window.location.href = 'https://salud.municipalidadrengo.cl/';
      })
    this.rengoForm = this.formBuilder.group({
      consultationType: ['', Validators.required],
      // cesfam: ['', Validators.required],
      rut: ['', [Validators.required, Validators.minLength(8)]],
      name: ['', Validators.required],
      // rut: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
      phoneNumber: ['', Validators.required],
      email: [null, [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")]],
      // consultation: ['', Validators.required],
      connectionType: [''],
      lendingName: ['', Validators.required],
    });

    this.firestoreService.getLendings().subscribe((lendingsSnapshot) => {
      this.virtualLendings = [];
      this.inSituLendings = [];

      lendingsSnapshot.forEach((conData: any) => {
        if (conData.payload.doc.data().lendingState == 'ACTIVO'){
          if (conData.payload.doc.data().lendingType === "Virtual") {
            this.virtualLendings.push({
              id: conData.payload.doc.id,
              data: conData.payload.doc.data()
            });
          } else {
            this.inSituLendings.push({
              id: conData.payload.doc.id,
              data: conData.payload.doc.data()
            });
          }
        }
      })
    });

    this.rengoForm.controls.rut.disable();
    this.rengoForm.controls.name.disable();
    this.rengoForm.controls.phoneNumber.disable();
    this.rengoForm.controls.email.disable();
    this.rengoForm.controls.lendingName.disable();
  }

  emailValidation(e) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (re.test(String(e).toLowerCase())) {
      this.validEmail = true;
    } else {
      this.validEmail = false;
    }
  }

  cleanRut(val) {
    return val.replace(/[^0-9kK]+/g, '').toUpperCase();
  }

  formatRUT(_value) {
    var result = _value.slice(-4, -1) + '-' + _value.substr(_value.length - 1);
    for (var i = 4; i < _value.length; i += 3) result = _value.slice(-3 - i, -i) + '.' + result;
    return result;
  }

  rutValidation(e) {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.isSpinning = true;
      let _v = this.cleanRut(this.rengoForm.controls.rut.value);
      if (_v.length < 8) {
        this.isSpinning = false;
      } else {
        let formattedRUT = this.formatRUT(_v);
        this.rengoForm.patchValue({
          rut: formattedRUT,
        });
        this.saludService.validarRut(formattedRUT)
          .subscribe( (resp: any) => {
            this.isSpinning = false;
            const {mensaje, status, paciente} = resp;
            if(!status){
              if(mensaje === 'rut no es valido'){
                swal({
                  title: " ¡Lo sentimos!",
                  text: "El RUT ingresado no es válido, por favor, intente nuevamente.",
                  buttonsStyling: false,
                  confirmButtonClass: "btn btn-success",
                  type: "success"
                }).then(() => {
                  this.rengoForm.patchValue({
                    rut: '',
                  });
                }).catch(swal.noop)
              }else{
                swal({
                  title: " ¡Lo sentimos!",
                  text: "El RUT ingresado no esta inscrito en Cesfam, debe acercarse al establecimiento para la inscripcion.",
                  buttonsStyling: false,
                  confirmButtonClass: "btn btn-success",
                  type: "success"
                }).then(() => {
                  window.location.href = 'https://salud.municipalidadrengo.cl/';
                }).catch(swal.noop)
              }
            }else{
              const nombrePaciente = paciente[1] + ' ' + paciente[2] + ' ' + paciente[3];
              let telefono = (paciente[13] === '' || paciente[13] === '0' || paciente[13] === '--') ? '' : paciente[13];
              let email = (paciente[14] === '' || paciente[14] === '--') ? '' : paciente[14];
              this.rengoForm.patchValue({
                name: nombrePaciente,
                phoneNumber: telefono,
                email: email,
              });
              this.rengoForm.controls.name.enable();
              this.rengoForm.controls.phoneNumber.enable();
              this.rengoForm.controls.email.enable();
              this.rengoForm.controls.lendingName.enable();
            }
          });
      }
      clearTimeout(this.timeout)
    },1000)
  }



  // onBlurRUT() {

  // }

  onSubmit() {
    let _v = this.cleanRut(this.rengoForm.controls.rut.value);
    if (_v.length < 8) {
      this.showError('Por favor, ingrese un RUT válido');
    } else {
      let obj = {
        // cesfamType: this.rengoForm.controls.cesfam.value,
        cesfamType: "CESFAM Rienzi Valencia Gonzalez",
        // consultationReason: this.rengoForm.controls.consultation.value,
        lendingName: this.rengoForm.controls.lendingName.value,
        consultationType: this.rengoForm.controls.consultationType.value,
        internetConnection: this.rengoForm.controls.connectionType ? this.rengoForm.controls.connectionType.value : '',
        link: "https://meet.jit.si/" + Date.now().toString(),
        mail: this.rengoForm.controls.email.value,
        name: this.rengoForm.controls.name.value,
        phoneNumber: this.rengoForm.controls.phoneNumber.value,
        rut: this.rengoForm.controls.rut.value,
        status: "Pendiente",
        creationDate: this.datePipe.transform(new Date(), "yyyy-MM-dd HH:mm:ss"),
        updatedDate: this.datePipe.transform(new Date(), "yyyy-MM-dd HH:mm:ss")
      }

      this.firestoreService.createConsultation(obj).then(() => {
        swal({
          title: "Consulta enviada!",
          text: "El requerimiento ha sido enviado correctamente. Una vez que se le asigne una hora, se le enviará toda la información al correo ingresado.",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-success",
          type: "success"
        }).then(() => {

          window.location.href = 'https://salud.municipalidadrengo.cl/';
        }).catch(swal.noop)

      }, (error) => {
        console.error(error);
      });
    }
  }

  goBack() {
    window.location.href = 'https://salud.municipalidadrengo.cl/';
  }

  showError(msg) {
    $.notify({
      message: msg
    }, {
      type: 'danger',
      timer: 3000,
      placement: {
        from: 'top',
        align: 'right'
      }
    });
  }

  onSelectChange(e) {
    this.rengoForm.controls.rut.enable();
    if (e === "Virtual") {
      this.sortedLendings = this.virtualLendings;
    } else {
      this.sortedLendings = this.inSituLendings;
    }
  }
}
